import { onCtxAbort, reaction } from '@reatom/framework'

import { selectedNetworkAtom } from '@root/entities/network'
import { isInitializationReadyOrWebsiteAtom } from '@root/features/initialization/atoms/common'
import { dependenciesAtom } from '@root/features/shared/dependencies'

export const initializePairActivitySocketAction = reaction((ctx) => {
  const { mainWebsocket } = ctx.get(dependenciesAtom)
  const isReady = ctx.spy(isInitializationReadyOrWebsiteAtom)

  if (!isReady) {
    return
  }

  const network = ctx.spy(selectedNetworkAtom)
  mainWebsocket.poolActivitySubscribeAction(ctx, { network })
  onCtxAbort(ctx, () => {
    mainWebsocket.poolActivityUnsubscribeAction(ctx, { network })
  })
}, 'initializePairActivitySocketAction')

export * from './reatom-pair-activity'
